var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655454644308,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4027,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M934 604c49.232 0 90 39.928 90 90v240c0 49.6-40.392 90-90 90H512c-49.776 0-90-40.576-90-90v-31.016c-108.8-7.2-210.512-53.376-289.056-131.92C47.216 685.328 0 572.016 0 452 0 203.632 203.568 0 452 0 700.368 0 904 203.568 904 452c0 52-8.88 103.76-25.832 152h55.832z m-18.912 60H531.232l192.688 169.936L915.088 664zM422 842.864v-60.24c-76.896-6.944-148.568-40.504-204.344-96.28C154.68 623.368 120 540.144 120 452 120 269.6 269.544 120 452 120 634.4 120 784 269.544 784 452c0 53.096-12.64 105.48-36.192 152h66.144c19.68-47.328 30.048-99.48 30.048-152 0-216.152-175.848-392-392-392s-392 175.848-392 392c0 206.056 159.808 375.488 362 390.864z m212-420.864a30 30 0 0 1 0 60H452a30 30 0 0 1-30-30V270a30 30 0 0 1 60 0v152h152z m-212 272c0-49.624 40.416-90 90-90h166.448c29.44-44.192 45.552-97.584 45.552-152 0-149.984-122.024-272-272-272s-272 122.016-272 272c0 139.84 106.08 255.36 242 270.336V694z m60 233.496l128.84-113.296L482 700.584v226.912z m49.344 36.504h383.752l-123.6-109.864-47.568 42.288a30 30 0 0 1-39.768 0.08l-47.96-42.296L531.344 964z m432.656-36.8V700.8l-127.344 113.2L964 927.2z",
    "p-id": 4028
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeMail);
export default __webpack_public_path__ + "static/media/time-mail.100fb3ce.svg";
export { ForwardRef as ReactComponent };